import { PDFLayout, PDFTable } from "ui/components/PDF";
import { RelatorioBaseData } from "core/features/relatorios/typings";
import { PDFTableColumn } from "ui/components/PDF/Table";
import { View } from "@react-pdf/renderer";
import PDFCapa from "components/PDF/Capa";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { PDFHeaderProps } from "./../Header";

interface PDFRelatorioBaseProps<T> {
  title: string;
  relatorioData: RelatorioBaseData & { items: T[] };
  columns: PDFTableColumn<T>[];
  totalRow?: number;
  includeDocumentWrapper?: boolean;
  includeAttachmentsPage?: boolean;
  pdfHeaderProps?: Partial<PDFHeaderProps>;
  includeMinHeight?: boolean;
  fontSize?: number;
}

function PDFRelatorioBase<T>({
  title,
  columns,
  relatorioData,
  totalRow,
  includeDocumentWrapper = true,
  includeAttachmentsPage = false,
  pdfHeaderProps,
  includeMinHeight = true,
  fontSize = 7,
}: PDFRelatorioBaseProps<T>) {
  const { tenant } = useCurrentTenant();

  return (
    <PDFLayout
      fontSize={fontSize}
      extraPages={
        includeAttachmentsPage
          ? [
              <PDFCapa
                key={1}
                title="Anexos de Despesas"
                includePeriodo={false}
                logoUrl={tenant.imagemUrl}
              />,
            ]
          : undefined
      }
      orientation="portrait"
      includeDocument={includeDocumentWrapper}
      assinaturas={relatorioData?.assinaturas}
      headerProps={{
        ...pdfHeaderProps,
        logo: relatorioData?.logo!,
        subTitle: relatorioData?.periodo!,
        tenant: relatorioData?.nomeTenant!,
        title,
      }}
      footerProps={{
        tenant: relatorioData?.nomeTenant!,
        logo: relatorioData?.logoAdm!,
        endereco1: relatorioData?.endereco1!,
        endereco2: relatorioData?.endereco2!,
      }}
    >
      <View style={{ minHeight: includeMinHeight ? "100%" : undefined }}>
        <PDFTable
          columns={columns}
          data={relatorioData.items}
          totalRow={totalRow}
        />
      </View>
    </PDFLayout>
  );
}

export default PDFRelatorioBase;
